module.exports = "https://lts-static.prod-my.games/promo/lp1/img/weapon-3.b8661e40.png";